import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { ServicePlan } from 'src/features/servicePlans/utils/types';

const RESOURCE = '/subscriptions/service-plan/';

type QueryFnType = typeof queryFn;

const queryFn = ({ ...params }: ListDTO): Promise<ListResponseAPI<ServicePlan>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends ListDTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_SERVICE_PLANS_RESOURCE, useQueryHook as useListServicePlans };
